import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10,
		fill: "currentColor"
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.28,9.106c0,4.081 -7.387,10.086 -7.387,10.086c0,0 -7.388,-6.006 -7.388,-10.086c0,-4.081 3.308,-7.387 7.388,-7.387c4.08,0 7.387,3.307 7.387,7.387Z",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.562,9.17c0,1.029 -0.834,1.864 -1.864,1.864c-1.028,0 -1.862,-0.834 -1.862,-1.864c0,-1.029 0.834,-1.864 1.862,-1.864c1.029,0 1.864,0.834 1.864,1.864",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.183,22.079l15.097,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		]
	})
});
export default SvgLocation;
